<template>
    <div>
        <div class="breadcrumb-container">
            <v-breadcrumbs :items="breadcrumbsItem"></v-breadcrumbs>
        </div>
        <div class="header header-container">
            <div class="text-header">
                {{ $vuetify.lang.t('$vuetify.inquiryForm.inquiry') }}
            </div>
            <div v-if="editable===true">
                <v-btn
                    @click="cancel()"
                    outlined
                    class="mr-4"
                    width="150"
                    color="primary">
                    {{ $vuetify.lang.t('$vuetify.inquiryForm.cancel') }}
                </v-btn>
                <v-btn
                    :disabled="!status"
                    :class="checkStatus(status)"
                    @click="save()"
                    width="150"
                    color="primary">
                    {{ $vuetify.lang.t('$vuetify.inquiryForm.save') }}
                </v-btn>
            </div>
        </div>
        <div class="inquiry-form-container locale-font">
            <v-card class="content-container inquiry-profile">
                <v-container class="pa-inquiry-review">
                    <v-row class="ma-0 card-header">
                        {{ $vuetify.lang.t('$vuetify.inquiryForm.profile') }}
                    </v-row>
                    <v-row>
                        <v-col cols="3" class="pt-0 profile-container">
                            <upload-image
                                :canDelete="false"
                                :isEditing="false"
                                :img="imgProfile(form.employeeImg)"  />
                        </v-col>
                        <v-col cols="9" class="pt-0">
                            <v-row>
                                <v-col cols="6">
                                    <div class="form-label">
                                        {{ $vuetify.lang.t('$vuetify.inquiryForm.employeeId') }}
                                    </div>
                                    <div class="form-text text-ellipsis">{{ form.employeeNo }}</div>
                                </v-col>
                                <v-col cols="6">
                                    <div class="form-label">
                                        {{ $vuetify.lang.t('$vuetify.inquiryForm.employeeFullname') }}
                                    </div>
                                    <div class="form-text text-ellipsis">{{ form.employeeFullname }}</div>
                                </v-col>
                                <v-col cols="6">
                                    <div class="form-label">
                                        {{ $vuetify.lang.t('$vuetify.inquiryForm.email') }}
                                    </div>
                                    <div class="form-text text-ellipsis">{{ form.email }}</div>
                                </v-col>
                                <v-col cols="6">
                                    <div class="form-label">
                                        {{ $vuetify.lang.t('$vuetify.inquiryForm.position') }}
                                    </div>
                                    <div class="form-text text-ellipsis">{{ form.position }}</div>
                                </v-col>
                                <v-col cols="12">
                                    <div class="form-label">
                                        {{ $vuetify.lang.t('$vuetify.inquiryForm.bureau') }}
                                    </div>
                                    <div class="form-text text-ellipsis">{{ form.bureau }}</div>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
            <v-card class="content-container inquiry-status">
                <v-container class="pa-inquiry-review">
                    <v-row class="ma-0 status-card-header">
                        <v-col cols="8" class="pa-0">
                            {{ $vuetify.lang.t('$vuetify.inquiryForm.inquiryStatus') }}
                        </v-col>
                        <v-col cols="4" class="pa-0 choices-container" v-if="editable===true">
                            <div
                                :class="choiceClass('APV')"
                                @click="changeStatus('APV')">
                                {{ $vuetify.lang.t('$vuetify.inquiryForm.approve') }}
                            </div>
                            <div
                                :class="choiceClass('REJ')"
                                @click="changeStatus('REJ')">
                                {{ $vuetify.lang.t('$vuetify.inquiryForm.reject') }}
                            </div>
                        </v-col>
                        <v-col cols="4" class="pa-0 choices-container" v-else>
                            <div :class="displayStatusStyle(form.status)">
                                <div class="mt-2">{{ displayStatusText(form.status) }}</div>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row class="ma-0 pt-5" ref="statusInquiryApproval">
                        <v-col cols="12" class="pa-0 inquiry-text">
                            {{ form.inquiryText }}
                        </v-col>
                    </v-row>
                    <v-row class="ma-0 pt-5">
                        <v-col class="pa-0" cols="8">
                            <div class="form-label">
                                {{ $vuetify.lang.t('$vuetify.inquiryForm.description') }}
                            </div>
                            <div class="form-text">{{ form.description }}</div>
                        </v-col>
                        <v-col class="pa-0" cols="4">
                            <div class="form-label">
                                {{ $vuetify.lang.t('$vuetify.inquiryForm.attachment') }}
                            </div>
                            <div class="download-container" @click="downloadFile(form.attachment)">
                                <div class="rectangle-attachment">
                                    <div class="download-icon">
                                        <i class="fas fa-file-download"></i>
                                    </div>
                                    <div class="download-file text-center">{{ $vuetify.lang.t('$vuetify.inquiryForm.downloadFile') }}</div>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row class="ma-0 pt-5" v-if="form.status !== 'PND'">
                        <v-col class="pa-0" cols="12">
                            <div class="form-label">
                                {{ displayReviewedText(form.status) }}
                            </div>
                            <div class="form-text">{{ `${$vuetify.lang.t('$vuetify.inquiryForm.date')}: ${form.reviewedDate}` }}</div>
                            <div class="form-text mt-1">{{ `${$vuetify.lang.t('$vuetify.inquiryForm.employeeId')}: ${form.reviewedByNo}` }}</div>
                            <div class="form-text mt-1">{{ `${$vuetify.lang.t('$vuetify.inquiryForm.employeeFullname')}: ${form.reviewedByFullname}` }}</div>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </div>
    </div>
</template>

<script>
import UploadImage from '@/components/UploadImage'
import profileDefault from '@/assets/user_default.png'

export default {
    name: 'InquiryForm',

    components: {
        UploadImage
    },

    computed: {
        breadcrumbsItem () {
            return [
                {
                    text: this.$vuetify.lang.t('$vuetify.inquiry.inquiryAndAttendance'),
                    disabled: false,
                    exact: true,
                    to: {
                        name: 'Inquiry'
                    }
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.inquiryForm.inquiry'),
                    disabled: true
                }
            ]
        }
    },

    data () {
        return {
            editable: false,
            inquiryId: null,
            status: null,
            form: {
                employeeImg: null,
                employeeNo: null,
                employeeFullname: null,
                email: null,
                position: null,
                bureau: null,
                inquiryText: null,
                description: null,
                attachment: null,
                type: null,
                status: null,
                reviewedDate: null,
                reviewedByNo: null,
                reviewedByFullname: null
            }
        }
    },

    methods: {
        imgProfile (img) {
            if (img) {
                return img
            } else {
                return profileDefault
            }
        },

        cancel () {
            this.$router.push({ name: 'Inquiry' }, () => {})
        },

        async save () {
            this.$store.dispatch('setLoading', true)
            const url = `inquiry/update-status/${this.inquiryId}`
            const form = {
                employeeNo: this.form.employeeNo,
                employeeFullname: this.form.employeeFullname,
                bureau: this.form.bureau,
                position: this.form.position,
                status: this.status
            }
            const res = await this.axios.put(url, form)
            this.$store.dispatch('setLoading', false)
            if (res && res.data && res.data.status === 'ok') {
                this.$notify({
                    title: this.$vuetify.lang.t('$vuetify.inquiryForm.congratulation'),
                    text: res.data.msg,
                    type: 'success'
                })
                this.$router.go(0)
            } else {
                this.$notify({
                    title: this.$vuetify.lang.t('$vuetify.inquiryForm.errorMessage'),
                    text: this.$vuetify.lang.t('$vuetify.inquiryForm.errorMessage'),
                    type: 'error'
                })
            }
        },

        async loadData (id) {
            await this.$store.dispatch('setLoading', true)
            const url = `inquiry/detail/${id}`
            const res = await this.axios.get(url)
            await this.$store.dispatch('setLoading', false)
            if (res && res.data && res.data.status === 'ok') {
                this.form = res.data.data
            }
        },

        choiceClass (statusChoice) {
            const style = 'choice'
            if (this.status === statusChoice) {
                return `${style} active`
            }

            return style
        },

        displayStatusStyle (status) {
            if (status === 'APV') {
                return 'status-style approve'
            } else if (status === 'REJ') {
                return 'status-style reject'
            } else {
                return 'status-style pending'
            }
        },

        displayStatusText (status) {
            if (status === 'APV') {
                return this.$vuetify.lang.t('$vuetify.inquiryForm.approve')
            } else if (status === 'REJ') {
                return this.$vuetify.lang.t('$vuetify.inquiryForm.reject')
            } else {
                return this.$vuetify.lang.t('$vuetify.inquiryForm.pending')
            }
        },

        displayReviewedText (status) {
            if (status === 'APV') {
                return this.$vuetify.lang.t('$vuetify.inquiryForm.approvedBy')
            } else if (status === 'REJ') {
                return this.$vuetify.lang.t('$vuetify.inquiryForm.rejectedBy')
            } else {
                return null
            }
        },

        checkStatus (statusChoice) {
            if (statusChoice !== null) {
                return 'btn-active'
            } else {
                return 'btn-inactive'
            }
        },

        changeStatus (statusChoice) {
            this.status = statusChoice
        },

        async downloadFile () {
            await this.$store.dispatch('setLoading', true)
            const url = `inquiry/download-attachment/${this.inquiryId}`
            const res = await this.axios.get(url, { responseType: 'blob' })
            if (res && res.data) {
                const contentType = res.headers['content-type']
                const splitedContentType = contentType.split('/')

                const blob = new Blob([res.data])
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = `inquiry-by-${this.form.employeeNo}.${splitedContentType[1]}`
                link.click()
                URL.revokeObjectURL(link.href)
                link.remove()
            }
            await this.$store.dispatch('setLoading', false)
        }
    },

    async mounted () {
        const { id, mode } = this.$route.params
        if (id) {
            this.editable = (mode === 'edit')
            this.inquiryId = id
            await this.loadData(this.inquiryId)
        }
    },
    watch: {
        '$vuetify.lang.current': {
            handler: async function (after, before) {
                if (this.inquiryId) {
                    await this.loadData(this.inquiryId)
                }
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
    .header-container {
        display: flex;
        justify-content: space-between;
        margin-bottom: 1rem;

        .btn-active {
            color: white;
        }
        .btn-inactive {
            color: #6c6c6c;
            background-color: #f6cbba !important;
        }
    }

    .pa-inquiry-review {
        padding: 20px 40px 40px 40px;
    }

    .inquiry-form-container {
        display: grid;
        min-height: 100%;
        height: 100%;
        margin-bottom: 1rem;
        grid-gap: 25px;
        grid-template-columns: calc(60% - 12.5px) calc(40% - 12.5px);
        color: white;

        .card-header {
            font-size: 24px;
            margin-bottom: 20px !important;
        }

        .status-card-header {
            font-size: 24px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .form-label {
            font-size: 14px;
            color: #6c6c6c;
            line-height: 1.29;
            margin-bottom: 5px;

            &:not(:first-child) {
                margin-top: 23px;
            }
        }

        .form-text {
            font-family: 'Roboto';
            font-size: 16px;
            line-height: 1.19;
            color: #131410;
        }

    }
    .inquiry-profile {
        grid-column: 1 / 1;
        grid-row: 1 / 3;
    }
    .inquiry-status {
        grid-column: 2 / 2;
        grid-row: 1 / 3;
    }

    .inquiry-text {
        color: #aa1a11;
    }

    .text-ellipsis {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .content-container {
        box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.05);
        border-radius: 15px !important;
    }

    .choices-container {
        display: inline-flex;
        justify-content: center;

        .disable {
            pointer-events: none;
            cursor: not-allowed;
        }

        .choice {
            font-size: 16px;
            height: 40px;
            min-width: 60px;
            width: 50%;
        }

        .choice:first-child {
            color: #6c98ba;
            border: solid 2px #6c98ba;
            border-top-left-radius: 25px;
            border-bottom-left-radius: 25px;

            &:hover {
                background-color: lighten($color: #6c98ba, $amount: 30);
            }

            &.active {
                color: white;
                background-color: #6c98ba;
            }
        }

        @media only screen and (max-width: 1850px) {
            .choice {
                min-width: 80px;
            }
        }

        @media only screen and (max-width: 1500px) {
            .choice {
                min-width: 70px;
            }
        }

        @media only screen and (max-width: 1390px) {
            .choice {
                min-width: 60px;
            }
        }

        .choice:last-child {
            color: #ff544a;
            border: solid 2px #ff544a;
            border-top-right-radius: 25px;
            border-bottom-right-radius: 25px;

            &:hover {
                background-color: lighten($color: #ff544a, $amount: 30);
            }

            &.active {
                color: white;
                background-color: #ff544a;
            }
        }
    }

    .status-style {
        display: inline-flex;
        justify-content: center;
        font-size: 16px;
        height: 40px;
        min-width: 120px;
        border-radius: 20px;
        color: white;

        &.approve {
            background-color: #6c98ba;
        }

        &.reject {
            background-color: #ff544a;
        }

        &.pending {
            background-color: #a8a8a8;
        }
    }

    .rectangle-attachment {
        text-align: center;
        margin: 10px 0 0;
        padding: 20px 15px 10px;
        border-radius: 10px;
        background-color: #faede7;
        cursor: pointer;

        .download-icon {
            font-size: 28px;
            color: #6c6c6c;
        }

        .download-file {
            color: #d76436;
        }
    }

    .upload-image-container {
        width: 120px;
    }

    ::v-deep .breadcrumb-container .v-breadcrumbs {
        padding-bottom: 18px;
    }
</style>
